import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminTestimonialUpdate from "../../../../views/admin/cms/testimonials/AdminTestimonialUpdate";
import AdminFaqUpdate from "../../../../views/admin/cms/faqs/AdminFaqUpdate";

const AdminFaqUpdatePage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminFaqUpdate />
      <AdminFooter />
    </div>
  );
};

export default AdminFaqUpdatePage;